module.exports = __webpack_public_path__ + "img/0-107.ca38b486.jpg";